import { render } from "./FooterView.vue?vue&type=template&id=48dfa094&scoped=true"
import script from "./FooterView.vue?vue&type=script&lang=js"
export * from "./FooterView.vue?vue&type=script&lang=js"

import "./FooterView.vue?vue&type=style&index=0&id=48dfa094&scoped=true&lang=css"

import exportComponent from "C:\\Users\\luke\\Desktop\\membership_application\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48dfa094"]])

export default __exports__